import { AfterViewInit, Component } from '@angular/core';
import { Router } from '@angular/router';
import { LMNavigationService } from '@navigation/lm-navigation.service';

@Component({
  selector: 'lm-action',
  template: `<div>Redirecting...</div>`,
})
export class LMActionComponent implements AfterViewInit {

  constructor(
    private router: Router,
    private lmNavigationService: LMNavigationService
  ) {}

  ngAfterViewInit() {
    this.redirect(this.router.url);
  }

  redirect(actionUrl: string) {
    const delimiter = actionUrl.indexOf('?') ===  -1 ? '?' : '&';
    actionUrl += delimiter + 'output=spec';
    this.lmNavigationService.runNavigation(actionUrl, undefined, { replaceUrl: true });
  }

  checkSaveRequired() {
    return false;
  }

  public allowPageNavigation(): Promise<boolean> | boolean {
    return true;
  }
}
